module.exports = __webpack_public_path__ + "05_mole.59b091d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer2/05_mole.png
// module id = Xv1z
// module chunks = 0